var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2204 0C18.5656 0 23.7268 5.05904 23.7268 11.2786C23.7268 14.213 22.5779 16.8893 20.6979 18.8979L24.3972 22.5163C24.7434 22.8557 24.7446 23.4047 24.3984 23.744C24.2259 23.9155 23.9978 24 23.771 24C23.5453 24 23.3184 23.9155 23.1447 23.7464L19.4008 20.0868C17.4313 21.6328 14.9342 22.5584 12.2204 22.5584C5.87527 22.5584 0.712891 17.4982 0.712891 11.2786C0.712891 5.05904 5.87527 0 12.2204 0ZM12.2204 1.73731C6.85245 1.73731 2.48528 6.01688 2.48528 11.2786C2.48528 16.5403 6.85245 20.8211 12.2204 20.8211C17.5872 20.8211 21.9544 16.5403 21.9544 11.2786C21.9544 6.01688 17.5872 1.73731 12.2204 1.73731Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.1c8116d27e111848121f3e16d25a38d6.svg";
export { ForwardRef as ReactComponent };